var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccordionPsycho6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.5H3C2.46957 19.5 1.96086 19.2893 1.58579 18.9142C1.21071 18.5391 1 18.0304 1 17.5V8.5M1 8.5H19M1 8.5V4.5C1 3.96957 1.21071 3.46086 1.58579 3.08579C1.96086 2.71071 2.46957 2.5 3 2.5H5M19 8.5V11.5M19 8.5V4.5C19 3.96957 18.7893 3.46086 18.4142 3.08579C18.0391 2.71071 17.5304 2.5 17 2.5H16.5M13 2.5V0.5M13 2.5V4.5M13 2.5H8.5M5 0.5V4.5M12.992 16.5H15.992M15.992 16.5H19M15.992 16.5V13.5M15.992 16.5V19.5",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccordionPsycho6);
export default __webpack_public_path__ + "static/media/IconAccordionPsycho6.a1b65151de171e39c562265306c5891a.svg";
export { ForwardRef as ReactComponent };